import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

const styles = [
  '/assets/css/plugins/animate.min.css',
  '/assets/css/main-1.css?v=6.1',
  '/assets/css/custom.css',
  'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.2/css/all.min.css',
];

const Layout = () => {
  const location = useLocation();

  useEffect(() => {
    const createdLinks = [];

    styles.forEach((href) => {
      if (!document.querySelector(`link[data-layout-style="${href}"]`)) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        link.setAttribute('data-layout-style', href);
        document.head.appendChild(link);
        createdLinks.push(link);
      }
    });

    return () => {
      createdLinks.forEach((link) => link.remove());
    };
  }, []);

  useEffect(() => {
    const isProductPage = location.pathname.startsWith('/product-detail');

    if (isProductPage) {
      document.body.classList.add('single-product');
    } else {
      document.body.classList.remove('single-product');
    }

    return () => {
      document.body.classList.remove('single-product');
    };
  }, [location.pathname]);

  return (
    <>
      <Header />
      <main className="main">
        <Outlet />
      </main>
      <Footer />
    </>
  );
};

export default Layout;